export default __webpack_public_path__ + "static/media/Alert.86a5c713.svg";